"use client"

import Image from 'next/image';
import React, { useState, useEffect } from 'react';
// import Link from 'next/link';
// import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from 'react-hook-form';
// import { toast } from 'react-hot-toast';
import { useSnackbar } from '@/context/SnackbarContext';
import Link from 'next/link';
// import { buildHeaders } from '@/utils/getApiBaseUrl';
import { pageService } from '@/services/pageServices';

interface RatingOption {
  value: number;
  label: string;
  icon: string;
}

const PopupWindowCopy: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  // const [rating, setRating] = useState<number | null>(null);
  // const [feedback, setFeedback] = useState<string>('');
  // const [name, setName] = useState<string>('');
  // const [email, setEmail] = useState<string>('');
  // const [contactConsent, setContactConsent] = useState<boolean>(false);
  // const [researchConsent, setResearchConsent] = useState<boolean>(false);
  const [animateIn, setAnimateIn] = useState<boolean>(false);
  // const recaptchaRef = useRef<ReCAPTCHA>(null);
  const { showSnackbar } = useSnackbar();
  // React Hook Form setup
  const { register, handleSubmit, reset, setValue, watch, formState: { errors } } = useForm<FormData>({
    defaultValues: {
      name: '',
      email: '',
      rating: 0,
      feedback: '',
      contact_consent: false,
      // recaptchaToken: '',
      // researchConsent: false,
    },
  });

  // Watch rating for custom UI
  const rating = watch('rating');
  // Remove unused feedback assignment
  const contactConsent = watch('contact_consent');
  // const researchConsent = watch('researchConsent');

  // Handle animation timing
  useEffect(() => {
    if (isOpen) {
      // Delay setting the animation state to true for a smoother effect
      setTimeout(() => setAnimateIn(true), 50);
    } else {
      setAnimateIn(false);
    }
  }, [isOpen]);

  const togglePopup = (): void => {
    if (isOpen) {
      // First animate out, then close
      setAnimateIn(false);
      setTimeout(() => setIsOpen(false), 500);
    } else {
      // Open first, animation is handled by useEffect
      setIsOpen(true);
    }
  };

  // Define form data type for react-hook-form
  interface FormData {
    name: string;
    email: string;
    rating: number;
    feedback: string;
    contact_consent: boolean;
    // recaptchaToken: string;
    // researchConsent: boolean;
  }

  const onSubmit = async (data: FormData) => {
    // const token = await recaptchaRef.current?.executeAsync();
    const payload = {
      ...data,
      rating: Number(data.rating),
      // recaptchaToken: token,
    };
    // console.log(payload);
    // console.log(recaptchaRef.current);
    // console.log("token", token, data.recaptchaToken);
    try {
      const response = await pageService.createFeedback(payload, window.location.hostname);
      if (response.success) {
        reset();
        togglePopup();
        // alert('Thank you for your feedback!');
        // toast.success('Thank you for your feedback!');
        showSnackbar({
          // message: 'Thank you for your feedback!',
          message: response.message,
          type: 'success',
        });
      } else {
        // toast.error('Failed to submit feedback.');
        showSnackbar({
          // message: 'Failed to submit feedback.',
          message: response.message,
          type: 'error',
        });
      }
    } catch {
      // toast.error('Error submitting feedback.');
      showSnackbar({
        message: 'Error submitting feedback.',
        type: 'error',
      });
    }
  };

  const ratingOptions: RatingOption[] = [
    // { value: 2, label: 'Terrible', icon: `/assets/logos/terrible.svg` },
    // { value: 4, label: 'Bad', icon: '/assets/logos/bad.svg' },
    // { value: 7, label: 'Okay', icon: '/assets/logos/okay.svg' },
    // { value: 9, label: 'Good', icon: '/assets/logos/good.svg' },
    // { value: 10, label: 'Amazing', icon: '/assets/logos/amazing.svg' }
    { value: 2, label: 'Terrible', icon: '/images/bd85de29-c3da-44ac-9158-76125db80141.jpg' },
    { value: 4, label: 'Bad', icon: '/images/c380b69c-3cdf-47e7-a686-fd6dff53adde.jpg' },
    { value: 7, label: 'Okay', icon: '/images/2d8c48ce-8815-4cd1-b8aa-540a6772b4dd.jpg' },
    { value: 9, label: 'Good', icon: '/images/38698357-dc99-404c-a376-451db6831dc2.jpg' },
    { value: 10, label: 'Amazing', icon: '/images/04f3954c-94c9-4f0b-93a5-90d2d47e4476.jpg' }
  ];

  // SVG background for the rate experience button
  const RateButtonSVGDesktop = () => (
    <svg width="64" height="552" viewBox="0 0 64 552" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" className="absolute inset-0 h-full w-full z-0">
      <g filter="url(#filter0_d_4145_861)">
        <path d="M0.647724 119.134L0.647728 32L-3.5 32L-3.50002 534L0.647706 534L0.64771 446.866C0.647711 429.845 14.4457 416.047 31.4665 416.047C35.6271 416.047 39 412.674 39 408.513L39 157.487C39 153.326 35.6271 149.953 31.4665 149.953C14.4458 149.953 0.647723 136.155 0.647724 119.134Z" fill="#0D121E" />
      </g>
      <defs>
        <filter id="filter0_d_4145_861" x="-28.5" y="0" width="92.5" height="552" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-7" />
          <feGaussianBlur stdDeviation="12.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.945344 0 0 0 0 0.485872 0 0 0 0 0.022106 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4145_861" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4145_861" result="shape" />
        </filter>
      </defs>
    </svg>
  );
  const RateButtonSVGMobile = ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 552 64"preserveAspectRatio='none' className={className}><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -0 64)"><g filter="url(#filter0_d_4145_861)"><path d="M0.647724 119.134L0.647728 32L-3.5 32L-3.50002 534L0.647706 534L0.64771 446.866C0.647711 429.845 14.4457 416.047 31.4665 416.047C35.6271 416.047 39 412.674 39 408.513L39 157.487C39 153.326 35.6271 149.953 31.4665 149.953C14.4458 149.953 0.647723 136.155 0.647724 119.134Z" fill="#0D121E" /></g><defs><filter id="filter0_d_4145_861" x="-28.5" y="0" width="92.5" height="552" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB"><feFlood floodOpacity="0" result="BackgroundImageFix" /><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" /><feOffset dy="-7" /><feGaussianBlur stdDeviation="12.5" /><feComposite in2="hardAlpha" operator="out" /><feColorMatrix type="matrix" values="0 0 0 0 0.945344 0 0 0 0 0.485872 0 0 0 0 0.022106 0 0 0 0.2 0" /><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4145_861" /><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4145_861" result="shape" /></filter></defs></g></svg>
  );

  // SVG background for close window button - using the same SVG pattern
  const CloseButtonSVGDesktop = () => (

    <svg viewBox="0 0 54 502" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute w-[45px] h-[502px] min-w-[45px] min-h-[502px] -left-[1.70rem] top-1/2 transform -translate-y-1/2 z-0">
      <path d="M2.6477 87.134V0H0V502H2.6477V414.866C2.6477 397.845 29.4457 384.047 46.4665 384.047C50.6271 384.047 54 380.674 54 376.513V125.487C54 121.326 50.6271 117.953 46.4665 117.953C29.4458 117.953 2.6477 104.155 2.6477 87.134Z" fill="#0D121E" />
    </svg>




  );
  const CloseButtonSVGMobile = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 502 54" preserveAspectRatio="none" className='w-full h-11'><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 0 54)"><g className="layer"><title>Layer 1</title><path d="m2.65,87.13l0,-87.13l-2.65,0l0,502l2.65,0l0,-87.13c0,-17.02 26.8,-30.82 43.82,-30.82c4.16,0 7.53,-3.38 7.53,-7.54l0,-251.02c0,-4.16 -3.37,-7.54 -7.53,-7.54c-17.02,0 -43.82,-13.79 -43.82,-30.82z" fill="#0D121E" id="svg_1" /></g></g></svg>
  );

  return (
    <>
      {/* Desktop rate button */}
      <div className="hidden md:block fixed left-0 top-1/2 transform -translate-y-1/2 z-50">
        {!isOpen && (
          <div className="relative md:w-16 w-14 h-[500px]">
            <RateButtonSVGDesktop />
            <button
              onClick={togglePopup}
              className="text-white text-left w-full h-full z-10 hover:opacity-90 "
             aria-label="Toggle options">
              <span
                className="font-medium text-lg whitespace-nowrap"
                style={{
                  writingMode: 'vertical-rl',
                  textOrientation: 'mixed',
                  transform: 'rotate(360deg)',
                }}
              >
                Rate your experience
              </span>
            </button>
          </div>
        )}
      </div>
      
      {/* Mobile rate button */}
      <div className="md:hidden fixed left-1/2 -translate-x-1/2 bottom-0 z-50 w-full h-16" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
        {!isOpen && (
          <div className="relative w-full h-full flex flex-col justify-center items-center">
            {/* Center the button above the SVG */}
            <button
              onClick={togglePopup}
              className="text-white text-center h-full z-10 hover:opacity-90 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pt-3"
             aria-label="Toggle options">
              <span className="font-medium text-lg whitespace-nowrap">
                Rate your experience
              </span>
            </button>

            {/* SVG Icon */}
            <RateButtonSVGMobile className='h-full w-full'/>
          </div>
        )}
      </div>

      {isOpen && (
        <div
          className={`fixed inset-0 bg-black z-[100] transition-opacity duration-500 flex md:items-center md:justify-start justify-center items-end ${animateIn ? 'bg-opacity-50' : 'bg-opacity-0'
            }`}
          onClick={togglePopup}
        >
          {/* Left-aligned popup container */}
          <div 
            className={`flex flex-col items-center md:w-[550px] w-screen md:max-h-[80vh] z-[200] transition-all duration-500 md:rounded-r-xl shadow-xl ${
              animateIn ? 'opacity-100 md:translate-x-0 translate-y-0' : 'opacity-0 md:-translate-x-full md:translate-y-0 translate-y-full'
            }`}
            onClick={e => e.stopPropagation()}
          >
            {/* Desktop close window button outside modal */}
            {isOpen && (
              <div className="absolute hidden md:block md:right-[-4.5rem] right-[-3.5rem] top-1/2 transform -translate-y-1/2 md:h-36 h-24 md:w-12 w-8 z-[220]">
                <CloseButtonSVGDesktop />
                <button
                  onClick={togglePopup}
                  className="absolute top-1/2  transform -translate-x-1/2 -translate-y-1/2 rotate-90 text-white flex items-center py-2 hover:opacity-90 transition-opacity z-[230]"
                  style={{
                    transform: 'translate(-50%, -50%) rotate(90deg)',
                    WebkitTransform: 'translate(-50%, -50%) rotate(90deg)',
                    transformOrigin: 'center center',
                    WebkitTransformOrigin: 'center center'
                  }}
                 aria-label="Close">
                  <span className="whitespace-nowrap font-medium text-lg">Close window</span>
                </button>
              </div>
            )}

            {/* Mobile close button - first item in flex column */}
            <div className="md:hidden w-screen flex justify-center items-center relative">
              <div className="relative w-full h-9">
                <CloseButtonSVGMobile />
                <button
                  onClick={togglePopup}
                  className="absolute inset-0 flex items-center justify-center text-white hover:opacity-90 transition-opacity z-[230]"
                 aria-label="Close">
                  <span className="whitespace-nowrap font-medium text-lg">Close window</span>
                </button>
              </div>
            </div>

            {/* Popup content */}
            <form onSubmit={handleSubmit(onSubmit)} className='w-full z-10'>
              <div className="md:py-4 py-2 md:px-8 px-4 z-50 border-l-4 md:border-l-0 border-r-4 border-b-4  border-t-4 rounded-l-xl md:rounded-l-none rounded-r-xl border-inkBlack bg-background">
                <h2 className="md:text-lg text-sm font-bold mb-1">Your Opinion Matters...</h2>
                {/* <p className="mb-4 text-sm">What do you think of your experience with People Matters!</p> */}
                <p className="mb-2 md:text-sm text-xs">How would you rate the content on the People Matters website?</p>
                <p className="mb-2 md:text-sm text-xs">We&apos;d love to hear your thoughts!</p>

                {/* Rating buttons */}
                <div className='mb-1'>
                  <div className="relative flex flex-row w-full justify-around gap-x-3 gap-0 pb-2">
                    {ratingOptions.map((option) => (
                      <label
                        key={option.value}
                        className={`flex flex-col w-full items-center py-0.5 border rounded-lg transition-all cursor-pointer ${Number(rating) === option.value
                          ? 'border-none bg-white shadow-lg'
                          : 'border bg-white/20'
                          }`}
                        style={{
                          boxShadow: Number(rating) === option.value ? '0 0 10px rgba(241, 124, 6, 0.4)' : 'none'
                        }}
                      >
                        <input
                          type="radio"
                          {...register('rating', { required: 'Rating is required', valueAsNumber: true })}
                          value={option.value}
                          checked={Number(rating) === option.value}
                          onChange={() => setValue('rating', option.value as number)}
                          className="sr-only"
                        />
                        <div
                          className="relative lg:w-10 lg:h-10 md:w-8 md:h-8 w-5 h-5 cursor-pointer"
                          onClick={() => setValue('rating', option.value as number)}
                        >
                          <Image
                            width={40}
                            height={40}
                            className={`${Number(rating) === option.value ? 'opacity-100' : 'opacity-30'}`}
                            alt={option.label}
                            src={`${process.env.NEXT_PUBLIC_ASSET_URL}${option.icon}`}
                            loading="lazy"
                          />
                        </div>
                        <span className={`${Number(rating) === option.value ? 'font-medium' : ''} md:text-sm text-[10px] sm:my-2 my-1`}>
                          {option.label}
                        </span>
                      </label>
                    ))}
                     {errors.rating && (
                      <span className="absolute left-0 text-right bottom-[-10px] text-red-500 text-xs block w-full pointer-events-none">{errors.rating.message}</span>
                    )}
                   
                  </div>
                 
                </div>

                {/* Name and Email */}
                <div className="mb-2 relative pb-2">
                  <label htmlFor="name" className="block mb-0.5 md:text-sm text-[10px] text-gray-500">
                    Name <span className="text-orange">*</span>
                  </label>
                  <input
                    id="name"
                    className="w-full border border-gray-300 rounded-md md:p-3 p-2 md:h-10 h-8 focus:outline-none focus:ring-2 focus:ring-orange"
                    {...register('name', { required: 'Name is required' })}
                    placeholder="Enter your name..."
                  />
                  {errors.name && (
                    <span className="absolute left-0 bottom-[-10px] text-red-500 text-xs block w-full text-right pointer-events-none">{errors.name.message}</span>
                  )}
                </div>
                <div className="mb-2 relative pb-2">
                  <label htmlFor="email" className="block mb-0.5 md:text-sm text-[10px] text-gray-500">
                    Email <span className="text-orange">*</span>
                  </label>
                  <input
                    id="email"
                    type="email"
                    className="w-full border border-gray-300 rounded-md md:p-3 p-2 md:h-10 h-8 focus:outline-none focus:ring-2 focus:ring-orange"
                    {...register('email', {
                      required: 'Email is required',
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: 'Invalid email address',
                      },
                    })}
                    placeholder="Enter your email..."
                  />
                  {errors.email && (
                    <span className="absolute left-0 bottom-[-10px] text-red-500 text-xs block w-full text-right pointer-events-none">{errors.email.message}</span>
                  )}
                </div>
                <div className="mb-3">
                  <label htmlFor="feedback" className="block mb-0.5 md:text-sm text-[10px] text-gray-500">
                    What are the main reasons for your rating?
                  </label>
                  <textarea
                    id="feedback"
                    className="w-full border border-gray-300 rounded-md md:p-3 p-2 md:h-28 h-20 focus:outline-none focus:ring-2 focus:ring-orange"
                    {...register('feedback')}
                    placeholder="Please share your feedback..."
                  />
                </div>

                {/* Consent checkboxes */}
                <div className="space-y-2 mb-6">
                  <div className="flex items-center relative pb-2">
                    <input
                      type="checkbox"
                      id="contact_consent"
                      className="accent-orange w-4 h-4"
                      {...register('contact_consent', { required: 'Consent is required' })}
                      checked={contactConsent}
                      onChange={() => setValue('contact_consent', !contactConsent)}
                    />
                    <label htmlFor="contact_consent" className="ml-2 text-gray-600 md:text-sm text-[10px]">
                      I may be contacted about this feedback. <Link href="/privacy-and-policy" className="text-orange hover:underline" prefetch={false}>Privacy Policy</Link>
                    </label>
                    {errors.contact_consent && (
                      <span className="absolute left-0 bottom-[-10px] text-red-500 text-xs block w-full text-left pointer-events-none">{errors.contact_consent.message}</span>
                    )}
                  </div>
                </div>

                {/* Submit button */}
                <button
                  className="w-full bg-orange text-white font-medium md:py-3 py-2 md:text-base text-[10px] rounded-md hover:bg-orange-600 transition-colors"
                 aria-label="Submit">
                  Submit
                </button>
              </div>
            </form>
            {/* <ReCAPTCHA
              ref={recaptchaRef}
              size="invisible"
              sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY as string}
              className="invisible"
            /> */}
          </div>
        </div>
      )}
      
      

    </>
  );
};

export default PopupWindowCopy;